
    <mat-form-field>
      <input matInput [matDatepicker]="picker" [(ngModel)]="value" (dateChange)="onDateChange($event)">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    </mat-form-field>
    <mat-datepicker #picker></mat-datepicker>
  